
import { RootState } from '../rootState';
import { GetterTree, MutationTree, Module } from 'vuex';
import { ApiConfig } from '@/configs/apiConfig';
import { i18n } from '@/plugins/i18n';

export interface IExternalEvents {
    onAddToVoxBox: (data: any, avatar: string) => void;
    onAddToCart: (data: any, avatar: string, quantity: number) => void;
    onSaveProject: (data: any, avatar: string) => void;
    onShareProject: (data: any, avatar: string) => void;
    onConfigurationChange: (date: any, extraData: any) => void;
}

export interface Configuration extends ApiConfig {
    appName: string;
    baseUrl: string;
    apiUrlConfig: string; // do informacji o meblu, presetach, cenach
    apiUrlPreset: string; // do pobierania plików (modeli, textur)
    apiConfigErp: string;
    appStyle: any;
    sceneStyle: any;
    menuStyle: any;
    productId: string;
    lang: string;
    events: IExternalEvents;
    presetCustomerUrl: string;
    productCustomerUrl: string;
    orderCondCalcUrl: string;
    productPreset: { id: string, code: string, name: string, codeErp: string, };
    appPreset: Array<{ name: string, url: string, avatar: string }>;
    appPresetInterior: Array<{ name: string, url: string, avatar: string }>;
    tiny: string;
    presetIndex: number;
    useLoading: boolean;
    showPopovers: string;
}

const getters: GetterTree<Configuration, RootState> = {
    configuration(state): Configuration {
        return state;
    },
};

const mutations: MutationTree<Configuration> = {
    setConfiguration(state, configuration: any) {
        const s = state as any;
        Object
            .keys(configuration)
            .filter((key) => key in s)
            .forEach((key) => s[key] = configuration[key]);
    },
    setEvents(state, events: any) {
        const s = state.events as any;
        Object
            .keys(events)
            .filter((key) => key in s)
            .forEach((key) => s[key] = events[key]);
    },
    setPresets(state, presets: any) {
        state.appPreset = presets.appPreset;
        state.appPresetInterior = presets.appPresetInterior;
    }
};

class CurrentState implements Configuration {

    public get lang(): string { return this._lang; }
    public set lang(value: string) {
        this._lang = value;
        i18n.locale = value;
    }
    public get productId() { return this.productPreset.code; }
    public get presetCustomerUrl() { return this.productCustomerUrl; }
    public appName = 'Creative';
    public baseUrl = 'https://localhost:44332';
    public apiUrlConfig = 'https://localhost:44332/api/config/';
    public apiUrlPreset = 'https://localhost:44332/api/download/';
    public apiConfigErp = 'https://www.meble.vox.pl/ofertavox/creative-conf';
    public appStyle = {};
    public sceneStyle = {};
    public menuStyle = {
        'overflow': 'auto',
        'background-color': 'white',
    };
    public events = {
        onAddToCart: () => { },
        onAddToVoxBox: () => { },
        onSaveProject: () => { },
        onShareProject: () => { },
        onConfigurationChange: () => { },
    };
    public productCustomerUrl = '';
    public productPreset = {
        id: '',
        code: '',
        name: '',
        codeErp: '',
    };
    public orderCondCalcUrl = '';
    public appPreset = [];
    public appPresetInterior = [];
    public tiny = "true";
    public presetIndex = 0;
    public useLoading = true;
    public showPopovers = 'true';

    private _lang = 'pl';
}
export const currentState = new CurrentState();

export const ConfigurationModule: Module<Configuration, RootState> = {
    state: currentState,
    getters,
    mutations,
};
